import { Link } from "react-router-dom";

export default function SessionExpired() {
  return (
    <div
      className="d-flex align-items-center justify-content-center bg-light"
      style={{ minHeight: "100vh" }}
    >
      <div
        className="card shadow p-4 text-center"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        <div className="mb-3">
          <i
            className="bi bi-exclamation-triangle-fill text-primary"
            style={{ fontSize: "4rem" }}
          ></i>
        </div>
        <h4 className="mb-3">Session Expired</h4>
        <p className="text-muted mb-4">
          Your session has expired. Please log in again to continue.
        </p>
        <Link to="/" className="btn btn-primary w-100">
          Login Again
        </Link>
      </div>
    </div>
  );
}

